/* eslint-disable no-async-promise-executor */
export const useRecaptcha = (recaptchaKey: string) => {
  const recaptchaUrl = new URL('https://www.google.com/recaptcha/api.js')
  recaptchaUrl.searchParams.set('render', recaptchaKey ?? '')

  const { load } = useScriptTag(recaptchaUrl.href, undefined, { manual: true })

  /**
   * @returns a promise containing the grecaptcha token
   */
  const resolve = () =>
    new Promise<string>(async (resolve, reject) => {
      try {
        await load()
        const { grecaptcha } = window
        grecaptcha.ready(() => grecaptcha
          .execute(recaptchaKey, { action: 'submit' })
          .then(resolve, reject),
        )
      }
      catch (error) {
        reject(error)
      }
    })

  return {
    resolve,
  }
}
